import { ChangeDetectorRef, Component, Injector, OnInit } from "@angular/core";
import { forkJoin } from "rxjs";
import { BaseComponent } from "../base/base.component";
import { ProjectTypeService } from "src/app/services/project-type/project-type.service";
import { ProjectType } from "../shared/model/projectType.model";
import { PostalService } from "src/app/services/postal/postal.service";
import { TownModel } from "../shared/model/town.model";
import { AnalystService } from "../services/analyst/analyst.service";
import { AnalystModel } from "../shared/model/Analyst.model";
import { SubmittalTypeService } from "../services/submittal-type/submittal-type.service";
import { DocumentTypeModel } from "../shared/model/DocumentType.model";
import { DeterminationService } from "../services/determination/determination.service";
import { DeterminationModel } from "../shared/model/Determination.model";
import { WatershedService } from "src/app/services/watershed/watershed.service";
import { Watershed } from "../shared/model/watershed.model";
import {
  ChipSearchParameterModel,
  SearchProjectModel,
} from "../shared/model/SearchProject.model";
import { PageSizeList } from "../services/PageSizeList";
import { ProjectService } from "../services/project/project.service";
import {
  PagedProjectList,
  ProjectSearchListItem,
} from "../services/project/project-search-list-item";
import { AgencyAction } from "../shared/model/AgencyAction.model";
import { ActionService } from "../services/action/action.service";
import { AgencyService } from "../services/agency/agency.service";
import { ThresholdService } from "../services/threshold/threshold.service";
import { RegulationService } from "../services/regulation/regulation.service";
import { ThresholdCategory } from "../shared/model/threshold-category.model";
import { SearchParameterService } from "../services/search-parameter/search-parameter.service";
import { AfterViewChecked } from "@angular/core";
import { Excel } from "../services/Excel/excel.service";
import { SubmittalService } from "../services/submittal/submittal.service";
import { DatePipe } from "@angular/common";
import { EMonitorMessageService } from "../services/e-monitor-message/e-monitor-message.service";
import { eMonitorMessageModel } from "../shared/model/eMonitor-message.model";
import { StateAgency } from "../shared/model/StateAgency.model";
import {
  NavigationEnd,
  NavigationError,
  NavigationStart,
} from "@angular/router";
import { SubmittalListItem } from "../services/project/submittal";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.css"],
})
export class SearchComponent
  extends BaseComponent
  implements OnInit, AfterViewChecked
{
  projectTypes: ProjectType[];
  projectTypeService: ProjectTypeService;
  postalService: PostalService;
  MassStateId: number = 22;
  Cities: TownModel[];
  analystService: AnalystService;
  analyst: AnalystModel;
  MepaAnalysts: Array<AnalystModel>;
  submittalTypeService: SubmittalTypeService;
  SubmittalTypes: Array<DocumentTypeModel>;
  determinations: DeterminationModel[];
  private determinationService: DeterminationService;
  watershedList: Array<Watershed>;
  private watershedService: WatershedService;
  currentPage: number;
  totalItems: number;
  isSearched = false;
  searchMessage: string;
  searchModel: SearchProjectModel;
  private projectService: ProjectService;
  fromPage: number;
  toPage: number;
  projects: ProjectSearchListItem[];
  fakeAgencyActions: any[];
  thresholds: any[];
  showBoundaryLinks = true;
  pageSizeList: Array<number>;
  DeterminationDisabled = false;
  readonly emptySubmittalType = [SearchComponent.selectOneDocumentType];
  disabledDates = true;
  public selectedAgencyAction: AgencyAction;
  public agencyActions = [];
  private actionService: ActionService;
  public selectedActions: [];
  public dropdownSettings = {};
  public agencies = [];
  public agenciesDropdownSettings = {};
  public thresholdsDropdownSettings = {};
  public regulationsDropdownSettings = {};
  public selectedAgencies: StateAgency[] = [];
  public selectedThresholds: [];
  public selectedRegulations: [];
  public regulations = [];
  private agencyService: AgencyService;
  private thresholdService: ThresholdService;
  private regulationService: RegulationService;
  public regulationsDisabled = true;
  private searchParameterService: SearchParameterService;
  chipSearchParameterList: ChipSearchParameterModel[] = [];
  removable = true;
  static readonly selectOneTown = new TownModel(
    -1,
    -1,
    "Select One",
    0,
    "-SELECT-",
    false,
    -1
  );
  static readonly selectOneProjectType = new ProjectType("", "Select one");
  static readonly selectOneMepaAnalyst = new AnalystModel(
    "",
    "Select",
    "One",
    null,
    null,
    null,
    null
  );
  static readonly selectOneDetermination = new DeterminationModel(
    null,
    "Select One"
  );
  static readonly selectOneWatershed = new Watershed(null, "Select One");
  static readonly selectOneDocumentType = new DocumentTypeModel(
    null,
    "Select One",
    "",
    null,
    false,
    false,
    false,
    false,
    "",
    ""
  );
  excelService: Excel;
  public datePipe: DatePipe;
  cityTownDisabled: boolean;
  eMonitorMessageService: EMonitorMessageService;
  announcement = new eMonitorMessageModel("", "");
  isOpen: boolean = false;

  constructor(
    public _injector: Injector,
    private changeDetector: ChangeDetectorRef,
    private submittalService: SubmittalService
  ) {
    super(_injector);
    this.projectTypeService = this._injector.get(ProjectTypeService);
    this.postalService = this._injector.get(PostalService);
    this.analystService = this._injector.get(AnalystService);
    this.submittalTypeService = this._injector.get(SubmittalTypeService);
    this.determinationService = this._injector.get(DeterminationService);
    this.watershedService = this._injector.get(WatershedService);
    this.projectService = this._injector.get(ProjectService);
    this.actionService = this._injector.get(ActionService);
    this.agencyService = this._injector.get(AgencyService);
    this.thresholdService = this._injector.get(ThresholdService);
    this.regulationService = this._injector.get(RegulationService);
    this.searchParameterService = this._injector.get(SearchParameterService);
    this.excelService = this._injector.get(Excel);
    this.datePipe = this._injector.get(DatePipe);
    this.eMonitorMessageService = this._injector.get(EMonitorMessageService);
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.pageSizeList = PageSizeList.getPageSizeList();
    this.showProgress();

    forkJoin([
      this.projectTypeService.getProjectTypes(),
      this.postalService.getStateTowns(this.MassStateId),
      this.analystService.GetAnalysts(),
      this.submittalTypeService.GetSubmittalTypes(),
      this.determinationService.GetDeterminations(),
      this.watershedService.GetWatersheds(),
      this.eMonitorMessageService.GetMessage("ProjectSearchMessage"),
    ]).subscribe(
      ([
        projectTypeResponse,
        towns,
        analysts,
        submittalTypes,
        determinations,
        watershedList,
        generalAnnouncement,
      ]) => {
        this.FillProjectTypesDropDown(projectTypeResponse);

        this.Cities = [SearchComponent.selectOneTown];
        this.Cities = this.Cities.concat(towns);

        this.FillAnalystDropDown(analysts);
        this.SubmittalTypes = this.emptySubmittalType.concat(submittalTypes);
        this.FillDeterminationsDropdown(determinations);
        this.FillWatershedsDropdown(watershedList);
        this.announcement = generalAnnouncement;
      }
    );
    forkJoin([
      this.agencyService.GetAgencies(),
      this.thresholdService.GetThresholds(),
    ]).subscribe(([agencies, thresholds]) => {
      this.agencies = agencies;
      this.actionService
        .GetActionsByAgenciesIds([])
        .subscribe((actions) => (this.agencyActions = actions));
      this.thresholds = thresholds;
    });

    this.dropdownSettings = {
      primaryKey: "actionId",
      labelKey: "actionName",
      searchPlaceholderText: "Select one or multiple Actions",
      singleSelection: false,
      text: "Select Actions",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "multi-select-dropdown",
      showCheckbox: true,
      enableCheckAll: true,
      searchAutofocus: true,
    };
    this.agenciesDropdownSettings = {
      primaryKey: "agencyId",
      labelKey: "agencyShortName",
      searchPlaceholderText: "Select one or multiple Agencies",
      singleSelection: false,
      text: "Select Agencies",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "multi-select-dropdown",
      showCheckbox: true,
      enableCheckAll: true,
      searchAutofocus: true,
    };
    this.thresholdsDropdownSettings = {
      primaryKey: "thresholdId",
      labelKey: "thresholdCategory",
      searchPlaceholderText: "Select one or multiple threshold",
      singleSelection: false,
      text: "Select Thresholds",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "multi-select-dropdown",
      showCheckbox: true,
      enableCheckAll: true,
      searchAutofocus: true,
    };
    this.DisableRegulations();
    this.searchModel = this.searchParameterService.ReadStoredSearchParameter();
    if (this.searchModel == null) {
      this.resetSearch();
    } else {
      this.onSearch();
    }
  }

  FillProjectTypesDropDown(projectTypeResponse: ProjectType[]) {
    const emptyProjectTypeList = [SearchComponent.selectOneProjectType];
    this.projectTypes = emptyProjectTypeList.concat(projectTypeResponse);
  }

  FillWatershedsDropdown(watershedList: Watershed[]) {
    const emptyWatershed = [SearchComponent.selectOneWatershed];
    if (watershedList != null && watershedList.length > 0) {
      this.watershedList = emptyWatershed.concat(watershedList);
    }
  }

  FillDeterminationsDropdown(determinations: DeterminationModel[]) {
    const emptyDetermination = [SearchComponent.selectOneDetermination];
    if (determinations != null && determinations.length > 0) {
      this.determinations = emptyDetermination.concat(determinations);
    }
  }

  onSearchClick() {
    this.currentPage = 0;
    this.totalItems = 0;
    this.isSearched = false;
    this.searchMessage = "";
    this.searchModel;
    this.searchModel.page = 1;
    this.searchModel.pageSize = PageSizeList.getPageSizeList()[2];
    this.onSearch();
  }

  resetSearch() {
    this.searchModel = new SearchProjectModel(
      "",
      "",
      "",
      this.emptySubmittalType[0],
      SearchComponent.selectOneTown,
      "Select One",
      null,
      null,
      SearchComponent.selectOneMepaAnalyst,
      0,
      SearchComponent.selectOneProjectType,
      "",
      SearchComponent.selectOneDetermination,
      SearchComponent.selectOneWatershed,
      [],
      [],
      [],
      [],
      false,
      50,
      1,
      null
    );
    this.searchParameterService.StoreSearchParameter(this.searchModel);
    this.onSearch();
  }

  onSearch() {
    this.searchParameterService.StoreSearchParameter(this.searchModel);
    this.showProgress();
    this.projectService
      .SearchProjects(this.searchModel)
      .subscribe((projects) => {
        this.chipSearchParameterList = this.searchModel.GetFilterList(
          this.datePipe
        );
        this.isSearched = true;
        this.currentPage = projects.currentPage;
        this.LoadSubmissionList(projects);
        this.UpdateTownNamesPerProject();
        this.hideProgress();
      });
  }

  UpdateTownNamesPerProject() {
    if (this.projects !== null && this.projects !== undefined) {
      this.projects.forEach((project) => {
        if (project.municipalId == "STATEWIDE") {
          project.townName = "STATEWIDE";
        } else {
          this.UpdateTownNamesInArray(project);
        }
      });
    }
  }

  private UpdateTownNamesInArray(project: ProjectSearchListItem) {
    var municipal_array = project.municipalId?.split(",");
    if (municipal_array != undefined) {
      this.UpdateTownNamesPerLocation(municipal_array, project);
    }
  }

  private UpdateTownNamesPerLocation(
    municipal_array: string[],
    project: ProjectSearchListItem
  ) {
    for (var i = 0; i < municipal_array.length; i++) {
      // Trim the excess whitespace.
      municipal_array[i] = municipal_array[i]
        .replace(/^\s*/, "")
        .replace(/\s*$/, "");
      if (municipal_array[i] !== "") {
        this.CallGetTown(municipal_array[i], project);
      }
    }
  }

  private CallGetTown(
    location: string,
    projectSearchListItem: ProjectSearchListItem
  ) {
    this.postalService.getTown(location).subscribe((town) => {
      if (
        projectSearchListItem.townName == "" ||
        projectSearchListItem.townName == undefined
      ) {
        projectSearchListItem.townName = town.TownName;
      } else {
        projectSearchListItem.townName += "," + town.TownName;
      }
    });
  }

  private FillAnalystDropDown(analysts: AnalystModel[]) {
    const selectItemNewElement = [SearchComponent.selectOneMepaAnalyst];
    this.MepaAnalysts = selectItemNewElement.concat(analysts);
  }

  private LoadSubmissionList(pagedProjectList: PagedProjectList) {
    this.totalItems = pagedProjectList.totalRecords;
    this.fromPage = (this.searchModel.page - 1) * this.searchModel.pageSize + 1;
    this.toPage =
      (this.searchModel.page - 1) * this.searchModel.pageSize +
      this.searchModel.pageSize;
    this.toPage = this.toPage > this.totalItems ? this.totalItems : this.toPage;
    if (pagedProjectList.list !== null && pagedProjectList.list.length !== 0) {
      this.projects = pagedProjectList.list;
      this.searchMessage = "";
    } else {
      this.projects = undefined;
      this.searchMessage = "No results.";
    }
  }

  PageChanged(value: { page: number }) {
    this.searchModel.page = value.page;
    this.onSearch();
  }

  onPageSizeChange() {
    this.onSearch();
  }

  SelectedDocumentType(selectedValue: DocumentTypeModel) {
    if (selectedValue.documentTypeId != null) {
      this.disabledDates = false;
    } else {
      this.disabledDates = true;
      this.searchModel.submittalDateFrom = null;
      this.searchModel.submittalDateTo = null;
    }
    if (selectedValue.intake == true) {
      this.DeterminationDisabled = false;
      this.DeterminationDisabled = true;
      this.searchModel.determination = null;
    } else {
      this.DeterminationDisabled = false;
    }
  }

  agenciesSelectionChange(selectedAgencies: any) {
    this.actionService
      .GetActionsByAgenciesIds(selectedAgencies)
      .subscribe((actions) => (this.agencyActions = actions));
  }

  thresholdSelectionChange(selectedThresholds: ThresholdCategory[]) {
    this.regulationService
      .GetRegulationsByThresholdCategoryIds(selectedThresholds)
      .subscribe((regulations) => {
        this.regulations = regulations;
        if (this.regulations.length > 0) {
          this.EnableRegulations();
        } else {
          this.DisableRegulations();
          this.searchModel.regulations = [];
        }
      });
  }

  DisableRegulations() {
    this.regulationsDropdownSettings = {
      primaryKey: "regulationId",
      labelKey: "regulationNumber",
      searchPlaceholderText: "Select one or multiple regulations.",
      singleSelection: false,
      text: "Select Regulations",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "multi-select-dropdown",
      showCheckbox: true,
      enableCheckAll: true,
      searchAutofocus: true,
      disabled: true,
    };
  }

  EnableRegulations() {
    this.regulationsDropdownSettings = {
      primaryKey: "regulationId",
      labelKey: "regulationNumber",
      searchPlaceholderText: "Select one or multiple regulations.",
      singleSelection: false,
      text: "Select Regulations",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "multi-select-dropdown",
      showCheckbox: true,
      enableCheckAll: true,
      searchAutofocus: true,
      disabled: false,
    };
  }

  GoToProject(project: ProjectSearchListItem) {
    this.router.navigateByUrl("project/" + project.projectId);
  }

  GoToSubmittal(project: any, submittal: any) {
    this.submittalService.setEeaNumber(project.eeaNo);
    this.submittalService.setProjectName(project.projectName);
  }

  remove(chipSearchParameter: ChipSearchParameterModel): void {
    this.RemoveSpecificParameter(
      chipSearchParameter.parameterName,
      this.searchModel
    );

    const index = this.chipSearchParameterList.indexOf(chipSearchParameter);
    if (index >= 0) {
      this.chipSearchParameterList.splice(index, 1);
    }

    this.onSearch();
  }

  RemoveSpecificParameter(
    parameterName: string,
    searchModel: SearchProjectModel
  ) {
    var parameterNames = {
      projectType: () => {
        searchModel.projectType = SearchComponent.selectOneProjectType;
      },
      town: function () {
        searchModel.town = SearchComponent.selectOneTown;
      },
      mepaAnalyst: function () {
        searchModel.mepaAnalyst = SearchComponent.selectOneMepaAnalyst;
      },
      submittalDateFrom: function () {
        searchModel.submittalDateFrom = null;
      },
      submittalDateTo: function () {
        searchModel.submittalDateTo = null;
      },
      determination: function () {
        searchModel.determination = SearchComponent.selectOneDetermination;
      },
      proponentName: function () {
        searchModel.proponentName = "";
      },
      submittalType: function () {
        searchModel.submittalType = SearchComponent.selectOneDocumentType;
      },
      projectNumber: function () {
        searchModel.projectNumber = "";
      },
      projectName: function () {
        searchModel.projectName = "";
      },
      watershed: function () {
        searchModel.watershed = SearchComponent.selectOneWatershed;
      },
      regulations: function () {
        searchModel.regulations = [];
      },
      thresholds: function () {
        searchModel.thresholds = [];
      },
      agencyActions: function () {
        searchModel.agencyActions = [];
      },
      agencies: function () {
        searchModel.agencies = [];
      },
    };

    parameterNames[parameterName]();
  }

  Print() {
    window.print();
  }

  exportAsXLSX(): void {
    let dataForExcel = [];
    this.projects.forEach((item) => {
      let allSubmittals = [];

      item.submittals.forEach((submittal) => {
        allSubmittals.push(submittal.submittalType);
      });

      dataForExcel.push(
        Object.values({
          EEA_Number: item.eeaNo,
          Project_Name: item.projectName,
          Location: item.location,
          City_Town: item.townName,
          Document_Type: allSubmittals.join(","),
          MEPA_Analyst: item.mepaAnalyst,
        })
      );
    });

    let reportData = {
      title: "Projects Report",
      data: dataForExcel,
      headers: Object.keys({
        "EEA No.": "",
        "Project Name": "",
        Location: "",
        "City/Town": "",
        "Document Type": "",
        "MEPA Analyst": "",
      }),
    };

    this.excelService.exportAsExcelFile(reportData);
  }

  onStatewideChange(e: { target: { checked: any; value: any } }) {
    if (e.target.checked) {
      this.cityTownDisabled = true;
    } else {
      this.cityTownDisabled = false;
    }
  }

  toggleLatitudeTooltip() {}
}
